const translations = {
  title: 'HTML Display',
  label: 'HTML Display',
};

export default translations;
